import { render, staticRenderFns } from "./TableauResultats.vue?vue&type=template&id=faab4c4e&scoped=true"
import script from "./TableauResultats.vue?vue&type=script&lang=js"
export * from "./TableauResultats.vue?vue&type=script&lang=js"
import style0 from "./TableauResultats.vue?vue&type=style&index=0&id=faab4c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faab4c4e",
  null
  
)

export default component.exports